import { CSSProperties } from 'styled-components';
import { theme } from '@goalsetter/ant-design-ui';
const { getDesignToken } = theme;

const globalToken = getDesignToken();

const imageStyles: CSSProperties = {
  width: '100%',
  aspectRatio: '2/1',
};

const titleStyle: CSSProperties = {
  textAlign: 'center',
  color: globalToken.colorTextLightSolid,
};

const descriptionStyle: CSSProperties = {
  textAlign: 'center',
  color: globalToken.colorTextLightSolid,
};

const contentStyle: CSSProperties = {
  marginBottom: globalToken.paddingLG,
};

export { imageStyles, titleStyle, descriptionStyle, contentStyle };
